"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOwnerFilterForDocumentsInProfilePage = getOwnerFilterForDocumentsInProfilePage;
exports.getFiltersForDocumentsInUserProfilePage_AllTab = getFiltersForDocumentsInUserProfilePage_AllTab;
exports.getFiltersForDocumentsInUserProfilePage_ProjectTab = getFiltersForDocumentsInUserProfilePage_ProjectTab;
exports.getFiltersForDocumentsInUserProfilePage_ComponentTab = getFiltersForDocumentsInUserProfilePage_ComponentTab;
exports.getFiltersForDocumentsInOrgProfilePage_AllTab = getFiltersForDocumentsInOrgProfilePage_AllTab;
exports.getFiltersForDocumentsInOrgProfilePage_ProjectTab = getFiltersForDocumentsInOrgProfilePage_ProjectTab;
exports.getFiltersForDocumentsInOrgProfilePage_ComponentTab = getFiltersForDocumentsInOrgProfilePage_ComponentTab;
const general_1 = require("./general");
function getOwnerFilterForDocumentsInProfilePage(profileUser) {
    // Business rule: once a document is organization owned it disappears from the user-who-created-it's profile
    // Eventually we should use the boolean ISearchData.is_organization_owned to filter out documents that are
    // organization owned, but until we backfill the search indexes, we can use the fact that the owner_handle of
    // an organization document won't match our profile's handle
    const ownerFilter = `owner_uid:${profileUser.uid} && owner_handle:${profileUser.handle}`;
    // TODO: eventually replace with the more rigorous
    // const ownerFilter = `owner_uid:${profileUser.uid} AND is_organization_owned:false`;
    return ownerFilter;
}
// Filters used in User Profile page (React component) - All tab
function getFiltersForDocumentsInUserProfilePage_AllTab(profileUser) {
    const ownerFilter = getOwnerFilterForDocumentsInProfilePage(profileUser);
    // NOTE: Below we are referring to is_published as it appears on ISearchDocumentData, _not_ on IDocumentData.
    return `${ownerFilter} ${(0, general_1.filterTestData)(true, "typesense")}`;
}
// Filters used in User Profile page (React component) - Project tab
function getFiltersForDocumentsInUserProfilePage_ProjectTab(profileUser) {
    const ownerFilter = getOwnerFilterForDocumentsInProfilePage(profileUser);
    // NOTE: Below we are referring to is_published as it appears on ISearchDocumentData, _not_ on IDocumentData.
    return `${ownerFilter} && is_published:false ${(0, general_1.filterTestData)(true, "typesense")}`;
}
// Filters used in User Profile page (React component) - Component tab
function getFiltersForDocumentsInUserProfilePage_ComponentTab(profileUser) {
    const ownerFilter = getOwnerFilterForDocumentsInProfilePage(profileUser);
    // NOTE: Below we are referring to is_published as it appears on ISearchDocumentData, _not_ on IDocumentData.
    return `${ownerFilter} && is_published:true ${(0, general_1.filterTestData)(true, "typesense")}`;
}
// Filters used in Org Profile page (React component) - All tab
function getFiltersForDocumentsInOrgProfilePage_AllTab(organization) {
    return `organization_owner_uid:${organization.uid} ${(0, general_1.filterTestData)(true, "typesense")}`;
}
// Filters used in Org Profile page (React component) - Project tab
function getFiltersForDocumentsInOrgProfilePage_ProjectTab(organization) {
    // NOTE: Below we are referring to is_published as it appears on ISearchDocumentData, _not_ on IDocumentData.
    return `organization_owner_uid:${organization.uid} && is_published:false ${(0, general_1.filterTestData)(true, "typesense")}`;
}
// Filters used in Org Profile page (React component) - Component tab
function getFiltersForDocumentsInOrgProfilePage_ComponentTab(organization) {
    // NOTE: Below we are referring to is_published as it appears on ISearchDocumentData, _not_ on IDocumentData.
    return `organization_owner_uid:${organization.uid} && is_published:true ${(0, general_1.filterTestData)(true, "typesense")}`;
}
//# sourceMappingURL=profile.js.map